module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b5257afbe4bcf7953029ddb8f18b24fe.svg";